exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2Z1uAZjkvc6ZdcQAnR0UQa{margin-top:20px}._2Z1uAZjkvc6ZdcQAnR0UQa h1{margin:1em auto}@media screen and (max-width:900px){._2Z1uAZjkvc6ZdcQAnR0UQa{margin-top:0}._2Z1uAZjkvc6ZdcQAnR0UQa h1{margin:.5em auto 1em;font-size:1.7em}}", ""]);

// exports
exports.locals = {
	"leaderboards": "_2Z1uAZjkvc6ZdcQAnR0UQa"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Leaderboards/Leaderboards.scss
 ** module id = 357
 ** module chunks = 0
 **/